import {
    ADD_BRANCH_ACTION,
    DELETE_BRANCH_ACTION,
    FULL_COVERAGE_BRANCH_ACTION,
    MODIFY_BRANCH_ACTION
} from '../../../actionType';

export default function (state=[],action){
    switch (action.type) {
        case ADD_BRANCH_ACTION:
            return [
                ...state,
                {
                    id:action.id,
                    key:action.key,
                    newOrExisting: action.newOrExisting,
                    branchCode: action.branchCode,
                    branchName: action.branchName,
                    branchType: action.branchType,
                    plotNumber:action.plotNumber,
                    streetName:action.streetName,
                    tradingCenter:action.tradingCenter,
                    buildingName:action.buildingName,
                    floorNumber:action.floorNumber,
                    shopNumber:action.shopNumber,
                    districtCity:action.districtCity,
                    countyMunicipality:action.countyMunicipality,
                    subCountyTownCouncilDivision:action.subCountyTownCouncilDivision,
                    parish:action.parish,
                    villageLocalCouncilZone:action.villageLocalCouncilZone,
                    registrationType:action.registrationType,
                    effectiveDate:action.effectiveDate,
                    EFDs:action.EFDs,
                    typeEffectiveDate:action.typeEffectiveDate,
                    invoicing:action.invoicing,
                    typeEinvoicingDate:action.typeEinvoicingDate,
                    applyDevices:action.applyDevices,
                    deviceGridData: action.deviceGridData,
                    deviceOrderList: action.deviceGridData,
                }
            ];
        case MODIFY_BRANCH_ACTION:
            const branchGridData = state;
            branchGridData[action.index] = action.branchInfo;
            return [
                ...branchGridData,
            ];
        case DELETE_BRANCH_ACTION:
            state.splice(action.index,1);
            return [...state];
        case FULL_COVERAGE_BRANCH_ACTION:
            return action.branchGridData;
        default:
            return state;
    }
}
